import { GameViewCustomClippingPage } from '@sportybot-web/features/game-view/components/game-view-custom-clipping-page';
import { customClipViewSearchSchema } from '@sportybot-web/features/game-view/schemas/game-view-params';
import { gameMediaQueryOptions } from '@sportybot-web/services/sporty-gateway/queries';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/_authenticated/game-view/custom-clipping')({
  component: RouteComponent,
  validateSearch: customClipViewSearchSchema,
});

function RouteComponent() {
  const {
    audioOffset,
    clipEnd,
    clipStart,
    date,
    gamePk,
    selectedAudioTrack,
    selectedFeedId,
    sportId,
  } = Route.useSearch();
  const navigate = Route.useNavigate();

  const handleClipStartChange = (value: number) => {
    void navigate({
      replace: true,
      search: (current) => {
        const nextClipStart = value;

        return {
          ...current,
          // clipStart can never follow clipEnd; push clipEnd out to meet it when it would.
          clipEnd:
            current.clipEnd !== undefined && nextClipStart > current.clipEnd
              ? nextClipStart
              : current.clipEnd,
          clipStart: nextClipStart,
        };
      },
    });
  };

  const handleClipEndChange = (value: number) => {
    void navigate({
      replace: true,
      search: (current) => {
        const nextClipEnd = value;

        return {
          ...current,
          clipEnd: nextClipEnd,
          // clipEnd can never precede clipStart; collapse clipStart onto it when it would.
          clipStart:
            current.clipStart !== undefined && nextClipEnd < current.clipStart
              ? nextClipEnd
              : current.clipStart,
        };
      },
    });
  };

  const handleAudioTrackChange = (value: string | undefined) => {
    void navigate({
      replace: true,
      search: (current) => ({ ...current, selectedAudioTrack: value }),
    });
  };

  const handleAudioOffsetChange = (value: number) => {
    void navigate({
      replace: true,
      search: (current) => ({ ...current, audioOffset: value }),
    });
  };

  const { data } = useQuery({ ...gameMediaQueryOptions({ gameDate: date, gamePk }) });

  useEffect(() => {
    const feeds = data?.gameMedia ?? [];

    if (!selectedFeedId && feeds.length > 0) {
      void navigate({ replace: true, search: (c) => ({ ...c, selectedFeedId: feeds[0].id }) });
    }
  }, [selectedFeedId, data, navigate]);

  return (
    <GameViewCustomClippingPage
      audioOffset={audioOffset}
      clipEnd={clipEnd}
      clipStart={clipStart}
      gameDate={date}
      gamePk={gamePk}
      onAudioOffsetChange={handleAudioOffsetChange}
      onAudioTrackChange={handleAudioTrackChange}
      onClipEndChange={handleClipEndChange}
      onClipStartChange={handleClipStartChange}
      selectedAudioTrack={selectedAudioTrack}
      selectedFeedId={selectedFeedId}
      sportId={sportId}
    />
  );
}
